import stocktakeQueries from './StocktakeQueries'

const stocktake = {
  stocktake: {
    ...stocktakeQueries,
  }
}

export default stocktake